export var LOCALE_COOKIE = 'NEXT_LOCALE';
export var REAL_DEPLOYED_DOMAIN = "speedlo_bez_fronty_server";
export var REDIRECT_AWAY_URL = 'https://speedlowaiter.cz/';
export var NOT_FOUND_REDIRECT_URL = 'https://speedlo.cz/error/404';
export var SEGMENT_ROUTE = "waiter"; // URLs that the app is deployed on

export var APP_DEPLOY_URLS = {
  local: "bez-fronty.dev.speedlo.cloud",
  // for local development use the dev URL as well because of BE
  dev: "bez-fronty.dev.speedlo.cloud",
  stage: "bez-fronty.stage.speedlo.cloud",
  stageBeta: "bez-fronty.stage2.speedlo.cloud",
  production: "bez-fronty.cz"
};